import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc7ca608"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "protected-avatar__fallback"
}

import { ref, watch, onBeforeUnmount, nextTick } from 'vue'
import { drawCircleCover, fetchAsImageBitmap, loadViaImage } from '@/utils/protectedImage'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProtectedAvatar',
  props: {
    src: {},
    size: { default: 40 }
  },
  setup(__props: any) {

const props = __props;



const canvasRef = ref<HTMLCanvasElement | null>(null)
const ready = ref(false)

let currentBitmap: ImageBitmap | null = null
let loadGeneration = 0
let abortController: AbortController | null = null

function draw() {
  const canvas = canvasRef.value
  if (!currentBitmap || !canvas) return
  drawCircleCover(canvas, currentBitmap, props.size, window.devicePixelRatio || 1)
}

function dispose() {
  ++loadGeneration
  if (abortController) {
    abortController.abort()
    abortController = null
  }
  if (currentBitmap) {
    currentBitmap.close()
    currentBitmap = null
  }
  ready.value = false
}

async function load(url: string) {
  dispose()
  const generation = ++loadGeneration
  abortController = new AbortController()

  try {
    let bitmap: ImageBitmap
    try {
      bitmap = await fetchAsImageBitmap(url, abortController.signal)
    } catch {
      if (generation !== loadGeneration) return
      // Fallback: legacy Azure Blob URLs may not have CORS configured
      bitmap = await loadViaImage(url)
    }
    if (generation !== loadGeneration) {
      bitmap.close()
      return
    }
    currentBitmap = bitmap
    ready.value = true
    await nextTick()
    draw()
  } catch {
    if (generation === loadGeneration) ready.value = false
  }
}

watch(
  () => props.src,
  (url) => {
    if (url) load(url)
    else dispose()
  },
  { immediate: true }
)

watch(
  () => props.size,
  () => {
    if (currentBitmap) {
      nextTick().then(draw)
    }
  }
)

onBeforeUnmount(() => {
  ++loadGeneration
  dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "protected-avatar isolate",
    style: _normalizeStyle({ width: _ctx.size + 'px', height: _ctx.size + 'px' })
  }, [
    _withDirectives(_createElementVNode("canvas", {
      ref_key: "canvasRef",
      ref: canvasRef,
      class: "protected-avatar__canvas"
    }, null, 512), [
      [_vShow, ready.value]
    ]),
    (!ready.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "protected-avatar__shield",
      onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
      onDragstart: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
    }, null, 32)
  ], 4))
}
}

})